import { MessagePrimitive } from '@assistant-ui/react';
import Message from './Message';

export default function UserMessage() {
	return (
		<MessagePrimitive.Root className="agent-user-message flex items-center justify-end mb-4">
			<Message className="agent-user-message-content !bg-user-chat-background !text-user-chat-foreground max-w-[70%]">
				<MessagePrimitive.Parts />
			</Message>
		</MessagePrimitive.Root>
	);
}
